<template>
  <div>
    <div class="right-panel">
      <!-- theme setting -->
      <template>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.THEME_SETTINGS)" v-on="on">
              <v-icon class="f-s-30">text_format</v-icon>
            </v-btn>
          </template>
          <span>Theme Setting</span>
        </v-tooltip>
      </template>
      <!-- history setting -->
      <template>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.HISTORY_SETTINGS)" v-on="on">
              <v-icon class="f-s-30">history</v-icon>
            </v-btn>
          </template>
          <span>Loan History</span>
        </v-tooltip>
      </template>
      <!-- related loans -->
      <template v-if="isShowWithLock()  && isShowResolve()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.RELATED_LOANS)" v-on="on">
              <v-icon class="f-s-30">account_tree</v-icon>
            </v-btn>
          </template>
          <span>Related Loans</span>
        </v-tooltip>
      </template>
      <!-- decision logic -->
      <template v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.INSTANT_BANK_VERIFICATION, dataType.PrivilegeType.EXECUTABLE)  && isShowResolve()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.DECISION_LOGIC)" v-on="on">
              <v-icon class="f-s-30">account_balance</v-icon>
            </v-btn>
          </template>
          <span>Instant Bank Verification</span>
        </v-tooltip>
      </template>
      <!-- optIn setting -->
      <template v-if="(isShowElement(authorization.privileges, dataType.PrivilegeCode.CUSTOMER_OPT_IN_SETTING, dataType.PrivilegeType.EXECUTABLE) || isWithdrawnLock()) && isShowResolve()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.OPT_IN)" v-on="on">
              <v-icon class="f-s-30">flaky</v-icon>
            </v-btn>
          </template>
          <span>Opt-In Setting</span>
        </v-tooltip>
      </template>
      <!-- Script setting -->
      <template
        v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.SCRIPT_OVERVIEW,  dataType.PrivilegeType.EXECUTABLE) && isShowScriptTemplate() && isShowResolve()"
      >
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.SCRIPT_SETTING)" v-on="on">
              <v-icon class="f-s-30">keyboard_voice</v-icon>
            </v-btn>
          </template>
          <span>Script Overview</span>
        </v-tooltip>
      </template>
      <!-- document history -->
      <template v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.DOCUMENT_OVERVIEW, dataType.PrivilegeType.EXECUTABLE) && isShowResolve()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.DOCUMENT_HISTORY)" v-on="on">
              <v-icon class="f-s-30">description</v-icon>
            </v-btn>
          </template>
          <span>Document Overview</span>
        </v-tooltip>
      </template>
      <!-- stamp verification -->
      <template v-if="(isShowElement(authorization.privileges, dataType.PrivilegeCode.STAMP_VERIFICATION, dataType.PrivilegeType.EXECUTABLE) || isOriginationSupervisorDisputePOC()) && isShowResolve()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.STAMP_VERIFICATION)" v-on="on">
              <v-icon class="f-s-30">approval</v-icon>
            </v-btn>
          </template>
          <span>Stamp Verification</span>
        </v-tooltip>
      </template>
      <!-- Instant Debit Card -->
      <template v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.INSTANT_DEBIT_CARD, dataType.PrivilegeType.EXECUTABLE) && isShowResolve()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.INSTANT_DEBIT)" v-on="on">
              <v-icon class="f-s-30">credit_card</v-icon>
            </v-btn>
          </template>
          <span>Instant Debit Card</span>
        </v-tooltip>
      </template>
      <template v-if="(isShowElement(authorization.privileges, dataType.PrivilegeCode.AUDIT, dataType.PrivilegeType.EXECUTABLE) && isShowAudit() && isShowResolve())">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.AUDIT_SETTING)" v-on="on">
              <v-icon class="f-s-30">rule</v-icon>
            </v-btn>
          </template>
          <span>AUDIT</span>
        </v-tooltip>
      </template>
      <!-- VWA Tracing -->
      <template v-if="isShowVwaTracing() && isShowResolve()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.VWA_TRACING)" v-on="on">
              <v-icon class="f-s-30">panorama_wide_angle_select</v-icon>
            </v-btn>
          </template>
          <span>VWA Tracing</span>
        </v-tooltip>
      </template>
      <!-- Complaint Handling-->
      <template v-if="isShowComplaint()">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   @click="openDrawer(drawer.COMPLAINT_HANDLING)" v-on="on">
              <v-icon class="f-s-30">mdi-message-text</v-icon>
            </v-btn>
          </template>
          <span>Complaint Handling</span>
        </v-tooltip>
      </template>
      <template v-if="isShowRelatedRequestCode() && isShowElement(authorization.privileges, dataType.PrivilegeCode.FRAUD_WARNING, dataType.PrivilegeType.EXECUTABLE)">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn small fab dark falt block class="setting-fab" color="primary"
                   style="padding-bottom: 2px"
                   @click="openDrawer(drawer.RELATED_REQUEST_CODE)" v-on="on">
              <head-alert :primary-color="'#fff'"></head-alert>
            </v-btn>
          </template>
          <span>Related Request Code</span>
        </v-tooltip>
      </template>
    </div>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="historyDrawer"
      hide-overlay
      fixed
      :width="840"
    >
      <history-settings :loan="loan" :privileges="authorization.privileges"></history-settings>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="themeDrawer"
      :width="300"
      hide-overlay
      fixed
    >
      <theme-settings></theme-settings>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="relatedLoans"
      :width="800"
      hide-overlay
      fixed
    >
      <related-loans ref="relatedLoansRef" :loan="loan" :authorization="authorization"></related-loans>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="decisionLogicDrawer"
      :width="1000"
      hide-overlay
      fixed
    >
      <decision-logic :loan="loan"></decision-logic>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="optInDrawer"
      :width="300"
      hide-overlay
      fixed
    >
      <opt-in-setting :loan="loan"></opt-in-setting>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="scriptDrawer"
      :width="1000"
      hide-overlay
      fixed
    >
      <script-setting :loan="loan"></script-setting>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="documentHistory"
      :width="1000"
      hide-overlay
      fixed
    >
      <document-history ref="documentHistoryRef" :loan="loan" :authorization="authorization"></document-history>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="stampVerification"
      :width="800"
      hide-overlay
      fixed
    >
      <stamp-verification :loan="loan" :authorization="authorization"></stamp-verification>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="instantDebit"
      :width="800"
      hide-overlay
      fixed
    >
      <instant-debit :loan="loan" :authorization="authorization" :slaveLoan="slaveLoan"></instant-debit>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="auditDrawer"
      :width="500"
      hide-overlay
      fixed
    >
      <audit-setting :loan="loan"></audit-setting>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="vwaTracing"
      :width="800"
      hide-overlay
      fixed
    >
      <vwa-tracing :loan="loan" :authorization="authorization" :slaveLoan="slaveLoan" :collectionProvider="collectionProvider"></vwa-tracing>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="complaintHandling"
      :width="800"
      hide-overlay
      fixed
    >
      <complaint-handling ref="complaintRef" :loan="loan" :authorization="authorization"></complaint-handling>
    </v-navigation-drawer>
    <v-navigation-drawer
        class="setting-drawer"
        temporary
        right
        v-model="relatedRequestCode"
        :width="800"
        hide-overlay
        fixed
    >
      <related-request-code :loan="loan" ref="requestCodeRef"></related-request-code>
    </v-navigation-drawer>
  </div>
</template>
<script>
import HistorySettings from '@/components/panda/common/detail/navigation/HistorySettings'
import OptInSetting from '@/components/panda/common/detail/navigation/OptInSetting'
import ThemeSettings from '@/components/panda/common/detail/navigation/ThemeSettings'
import DecisionLogic from '@/components/panda/common/detail/navigation/DecisionLogic'
import ScriptSetting from '@/components/panda/common/detail/navigation/ScriptSetting'
import DocumentHistory from '@/components/panda/common/detail/navigation/DocumentHistory'
import StampVerification from '@/components/panda/common/detail/navigation/StampVerification'
import InstantDebit from '@/components/panda/common/detail/navigation/InstantDebit'
import RelatedLoans from '@/components/panda/common/detail/navigation/RelatedLoans'
import AuditSetting from '@/components/panda/common/detail/navigation/AuditSetting'
import VwaTracing from '@/components/panda/collection/detail/navigation/VwaTracing'
import ComplaintHandling from '@/components/panda/common/detail/navigation/ComplaintHandling'
import RelatedRequestCode from '@/components/panda/common/detail/navigation/RelatedRequestCode'
import HeadAlert from '@/components/panda/pre-origination/detail/HeadAlert'
import { Authentication, DataType, Tool } from '@/util/index'
const tool = new Tool()
const DRAWER = {
  HISTORY_SETTINGS: 'history-settings',
  OPT_IN: 'opt-in',
  THEME_SETTINGS: 'theme-settings',
  DECISION_LOGIC: 'decision-logic',
  SCRIPT_SETTING: 'script-setting',
  DOCUMENT_HISTORY: 'document-history',
  STAMP_VERIFICATION: 'stamp-verification',
  INSTANT_DEBIT: 'instant-debit',
  RELATED_LOANS: 'related-loans',
  AUDIT_SETTING: 'audit_setting',
  VWA_TRACING: 'vwa-tracing',
  COMPLAINT_HANDLING: 'complaint-handling',
  RELATED_REQUEST_CODE: 'related-request-code'
}
export default {
  name: 'RightPanel',
  components: {
    AuditSetting,
    OptInSetting,
    ThemeSettings,
    HistorySettings,
    DecisionLogic,
    ScriptSetting,
    DocumentHistory,
    StampVerification,
    InstantDebit,
    RelatedLoans,
    VwaTracing,
    ComplaintHandling,
    RelatedRequestCode,
    HeadAlert
  },
  props: {
    loan: Object,
    authorization: Object,
    slaveLoan: Object,
    slaveLoanId: Number,
    collectionProvider: Number
  },
  data () {
    return {
      themeDrawer: false,
      optInDrawer: false,
      historyDrawer: false,
      decisionLogicDrawer: false,
      scriptDrawer: false,
      documentHistory: false,
      stampVerification: false,
      instantDebit: false,
      relatedLoans: false,
      auditDrawer: false,
      vwaTracing: false,
      complaintHandling: false,
      relatedRequestCode: false,
      currentSpeechCraft: [],
      dataType: DataType,
      currentLockedId: -1,
      drawer: DRAWER,
      complaintStatus: '',
      complaintStatusData: '',
      broadcastOperatorId: '',
      documentType: ''
    }
  },
  mounted () {
    this.$eventBus.$on('broadcastLockedId', target => {
      this.currentLockedId = target
      this.$forceUpdate()
    })
    this.$eventBus.$on('complaintStatus', target => {
      this.complaintStatusData = target
      this.$forceUpdate()
    })
  },
  methods: {
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value) &&
        Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    isWithdrawnLock () {
      return tool.isWithdrawnStatus(this.loan.loanStatus) && Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    isOriginationSupervisorDisputePOC () {
      return this.store.getters.getRoleCode === DataType.RoleEnum.ORIGINATION_SUPERVISOR_DISPUTE_POC.code
    },
    isShowWithLock () {
      const roleCode = this.store.getters.getRoleCode
      const RoleEnum = [
        DataType.RoleEnum.ORIGINATION_SUPERVISOR.code,
        DataType.RoleEnum.ORIGINATION_SUPERVISOR_DISPUTE_POC.code,
        DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code,
        DataType.RoleEnum.PRODUCTION_MANAGER.code,
        DataType.RoleEnum.CORRECTION_SUPERVISOR.code,
        DataType.RoleEnum.OPERATIONS_SUPERVISOR_POC.code,
        DataType.RoleEnum.RETURNING_CUSTOMER_SUPERVISOR.code,
        DataType.RoleEnum.ADMINISTRATOR.code
      ]
      return (RoleEnum.includes(roleCode) || Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId))
    },
    isShowScriptTemplate () {
      let result = false
      if (tool.isNotEmpty(this.loan) && tool.isNotEmpty(this.loan.loanType) &&
        this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        result = true
      }
      return result
    },
    isShowAudit () {
      return this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value ||
        this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value ||
        this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value ||
        this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value || this.complaintStatus === 3 ||
        this.loan.loanStatus === DataType.LoanStatus.TRIBE_NOAA_REVIEW.value
    },
    isShowResolve () {
      if (tool.isEmpty(this.complaintStatusData)) {
        return tool.isEmpty(this.complaintStatusData)
      } else {
        this.complaintStatus = this.complaintStatusData.complaintStatus
        if (this.complaintStatus === 3) {
          return true
        } else if (this.complaintStatus === 1 || this.complaintStatus === 2) {
          return false
        }
      }
    },
    isShowComplaint () {
      return Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId) && tool.isNotEmpty(this.complaintStatus)
    },
    isShowVwaTracing () {
      return this.collectionProvider !== DataType.CollectionProviderEnum.THIRD_PARTY.value
    },
    isShowRelatedRequestCode () {
      return true
    },
    openDrawer (drawer) {
      switch (drawer) {
        case DRAWER.THEME_SETTINGS:
          this.themeDrawer = (!this.themeDrawer)
          break
        case DRAWER.OPT_IN:
          this.optInDrawer = (!this.optInDrawer)
          this.$eventBus.$emit('optInSettings')
          break
        case DRAWER.HISTORY_SETTINGS:
          this.historyDrawer = (!this.historyDrawer)
          break
        case DRAWER.DECISION_LOGIC:
          this.$eventBus.$emit('initDecisionLogic')
          this.decisionLogicDrawer = !this.decisionLogicDrawer
          break
        case DRAWER.SCRIPT_SETTING:
          this.scriptDrawer = !this.scriptDrawer
          this.$eventBus.$emit('getSpeechCraftTemplate')
          break
        case DRAWER.DOCUMENT_HISTORY:
          this.documentHistory = !this.documentHistory
          this.$eventBus.$on('documentType', target => {
            this.documentType = target
          })
          if (tool.isEmpty(this.documentType)) {
            this.$refs.documentHistoryRef.showHistory('DOCUMENT')
          } else {
            this.$refs.documentHistoryRef.showHistory(this.documentType)
          }

          break
        case DRAWER.STAMP_VERIFICATION:
          this.stampVerification = !this.stampVerification
          break
        case DRAWER.INSTANT_DEBIT:
          this.instantDebit = !this.instantDebit
          break
        case DRAWER.RELATED_LOANS:
          this.relatedLoans = !this.relatedLoans
          if (this.relatedLoans) {
            this.$refs.relatedLoansRef.getRelatedLoans(
              {
                email: this.store.getters.getLoan.email,
                phone: this.store.getters.getLoan.homePhone,
                portfolioList: [],
                ssn: this.store.getters.getLoan.ssn,
                accountNo: this.store.getters.getLoan.accountNo
              }
            )
            this.relatedLoans = true
          } else {
            this.relatedLoans = false
          }
          break
        case DRAWER.AUDIT_SETTING:
          this.auditDrawer = (!this.auditDrawer)
          break
        case DRAWER.VWA_TRACING:
          this.$eventBus.$emit('initEmployerInfo')
          this.vwaTracing = (!this.vwaTracing)
          break
        case DRAWER.COMPLAINT_HANDLING:
          this.complaintHandling = (!this.complaintHandling)
          if (this.complaintHandling) {
            this.$refs.complaintRef.getComplaintDetail()
          }
          break
        case DRAWER.RELATED_REQUEST_CODE:
          this.$eventBus.$emit('initRelatedRequestCode', this.slaveLoanId)
          this.relatedRequestCode = (!this.relatedRequestCode)
          if (this.relatedRequestCode) {
            this.$refs.requestCodeRef.getRelatedRequestCode()
          }
          break
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.setting-drawer {
  padding: 0;
  border-radius: 8px 0px 0px 8px;
  box-shadow: none;
  background: #F9FAFD;
}
.right-panel {
  position: fixed;
  right: 0;
  top: calc(100vh - 65%);
  z-index: 5;
}
.setting-fab {
  margin: 0px 0px 10px;
  border-radius: 0;
}
.setting-fab + .setting-fab {
  margin-top: 10px;
}
</style>
